import { render, staticRenderFns } from "./addFinger.vue?vue&type=template&id=964ff78a&scoped=true&"
import script from "./addFinger.vue?vue&type=script&lang=js&"
export * from "./addFinger.vue?vue&type=script&lang=js&"
import style0 from "./addFinger.vue?vue&type=style&index=0&id=964ff78a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964ff78a",
  null
  
)

export default component.exports